@file:OptIn(InternalResourceApi::class)

package aicombo.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/aicombo.composeapp.generated.resources/"

internal val Res.drawable.add: DrawableResource by lazy {
      DrawableResource("drawable:add", setOf(
        ResourceItem(setOf(), "${MD}drawable/add.xml", -1, -1),
      ))
    }

internal val Res.drawable.arrow_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_left.xml", -1, -1),
      ))
    }

internal val Res.drawable.arrow_rigt: DrawableResource by lazy {
      DrawableResource("drawable:arrow_rigt", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_rigt.xml", -1, -1),
      ))
    }

internal val Res.drawable.book_outline: DrawableResource by lazy {
      DrawableResource("drawable:book_outline", setOf(
        ResourceItem(setOf(), "${MD}drawable/book_outline.xml", -1, -1),
      ))
    }

internal val Res.drawable.copy: DrawableResource by lazy {
      DrawableResource("drawable:copy", setOf(
        ResourceItem(setOf(), "${MD}drawable/copy.xml", -1, -1),
      ))
    }

internal val Res.drawable.cross_m: DrawableResource by lazy {
      DrawableResource("drawable:cross_m", setOf(
        ResourceItem(setOf(), "${MD}drawable/cross_m.xml", -1, -1),
      ))
    }

internal val Res.drawable.edit_2: DrawableResource by lazy {
      DrawableResource("drawable:edit_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/edit_2.xml", -1, -1),
      ))
    }

internal val Res.drawable.eye: DrawableResource by lazy {
      DrawableResource("drawable:eye", setOf(
        ResourceItem(setOf(), "${MD}drawable/eye.xml", -1, -1),
      ))
    }

internal val Res.drawable.eye_line: DrawableResource by lazy {
      DrawableResource("drawable:eye_line", setOf(
        ResourceItem(setOf(), "${MD}drawable/eye_line.xml", -1, -1),
      ))
    }

internal val Res.drawable.home_outline: DrawableResource by lazy {
      DrawableResource("drawable:home_outline", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_outline.xml", -1, -1),
      ))
    }

internal val Res.drawable.magicpen_filled: DrawableResource by lazy {
      DrawableResource("drawable:magicpen_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/magicpen_filled.xml", -1, -1),
      ))
    }

internal val Res.drawable.magicpen_outlined: DrawableResource by lazy {
      DrawableResource("drawable:magicpen_outlined", setOf(
        ResourceItem(setOf(), "${MD}drawable/magicpen_outlined.xml", -1, -1),
      ))
    }

internal val Res.drawable.menu: DrawableResource by lazy {
      DrawableResource("drawable:menu", setOf(
        ResourceItem(setOf(), "${MD}drawable/menu.xml", -1, -1),
      ))
    }

internal val Res.drawable.more: DrawableResource by lazy {
      DrawableResource("drawable:more", setOf(
        ResourceItem(setOf(), "${MD}drawable/more.xml", -1, -1),
      ))
    }

internal val Res.drawable.play: DrawableResource by lazy {
      DrawableResource("drawable:play", setOf(
        ResourceItem(setOf(), "${MD}drawable/play.xml", -1, -1),
      ))
    }

internal val Res.drawable.search: DrawableResource by lazy {
      DrawableResource("drawable:search", setOf(
        ResourceItem(setOf(), "${MD}drawable/search.xml", -1, -1),
      ))
    }

internal val Res.drawable.settings_outline: DrawableResource by lazy {
      DrawableResource("drawable:settings_outline", setOf(
        ResourceItem(setOf(), "${MD}drawable/settings_outline.xml", -1, -1),
      ))
    }

internal val Res.drawable.stop: DrawableResource by lazy {
      DrawableResource("drawable:stop", setOf(
        ResourceItem(setOf(), "${MD}drawable/stop.xml", -1, -1),
      ))
    }

internal val Res.drawable.user_outline: DrawableResource by lazy {
      DrawableResource("drawable:user_outline", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_outline.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("add", Res.drawable.add)
  map.put("arrow_left", Res.drawable.arrow_left)
  map.put("arrow_rigt", Res.drawable.arrow_rigt)
  map.put("book_outline", Res.drawable.book_outline)
  map.put("copy", Res.drawable.copy)
  map.put("cross_m", Res.drawable.cross_m)
  map.put("edit_2", Res.drawable.edit_2)
  map.put("eye", Res.drawable.eye)
  map.put("eye_line", Res.drawable.eye_line)
  map.put("home_outline", Res.drawable.home_outline)
  map.put("magicpen_filled", Res.drawable.magicpen_filled)
  map.put("magicpen_outlined", Res.drawable.magicpen_outlined)
  map.put("menu", Res.drawable.menu)
  map.put("more", Res.drawable.more)
  map.put("play", Res.drawable.play)
  map.put("search", Res.drawable.search)
  map.put("settings_outline", Res.drawable.settings_outline)
  map.put("stop", Res.drawable.stop)
  map.put("user_outline", Res.drawable.user_outline)
}
